import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('p4c_token'));
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      try {
        await axios.get(`${API}/admin/verify`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setIsAdmin(true);
      } catch {
        setIsAdmin(false);
        localStorage.removeItem('p4c_token');
        setToken(null);
      }
      setLoading(false);
    };
    verify();
  }, [token]);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    const { token: newToken } = res.data;
    localStorage.setItem('p4c_token', newToken);
    setToken(newToken);
    setIsAdmin(true);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('p4c_token');
    setToken(null);
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ token, isAdmin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
